import { render, staticRenderFns } from "./Debts.vue?vue&type=template&id=4a474e38&scoped=true&"
import script from "./Debts.vue?vue&type=script&lang=js&"
export * from "./Debts.vue?vue&type=script&lang=js&"
import style0 from "./Debts.vue?vue&type=style&index=0&id=4a474e38&lang=scss&scoped=true&"
import style1 from "./Debts.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a474e38",
  null
  
)

export default component.exports